import {useEffect, useState} from "react";
import DataBlockLabel from "../account/DataBlockLabel";

export default function SelectDeliveryWeek({
                                               errors,
                                               register,
                                               watch,
                                               isRequired = true
                                           }) {


    const [isChrome, setIsChrome] = useState();
    // const [content, setContent] = useState();

    // const getContent = async () => {
    //     const pageData = await fetch(
    //         process.env.NEXT_PUBLIC_CRAFT_BASE_URL + "/api/global-sets/order",
    //         {
    //             method: "get",
    //             headers: {
    //                 Accept: "application/json",
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     ).then((response) => {
    //         if (!response.ok) {
    //             return [];
    //         }
    //
    //         return response.json();
    //
    //     });
    //
    //     setContent(pageData ?? []);
    // }

    useEffect(() => {
        let browser = navigator.userAgent;
        if (browser.includes("Chrome")) {
            setIsChrome(true);
        } else {
            setIsChrome(false);
        }

        // getContent();

    }, []);

    const getMinWeekSelect = () => {
        // const addToWeek = content?.delivery_week?.optelling ?? 0;
        const addToWeek = 0;

        var currentDate = new Date();
        var startDate = new Date(currentDate.getFullYear(), 0, 1);
        var days = Math.floor((currentDate - startDate) / (24 * 60 * 60 * 1000));

        var day = currentDate.getDay();
        var hour = currentDate.getHours();
        var year = currentDate.getFullYear();
        var weekNumber = Math.ceil(days / 7);

        if ((day === 4 && hour >= 12) || day > 4 || day === 0) {
            for (var i = 0; i < 2; i++) {
                if (weekNumber === 52) {
                    weekNumber = 1;
                    year = year + 1;
                    break;
                }
                weekNumber = weekNumber + (1 + addToWeek);
            }
        } else {
            if (weekNumber === 52) {
                weekNumber = 1;
                year = year + 1;
            }
            weekNumber = weekNumber + 1;
        }
        let minWeekSelect = "";
        if (weekNumber <= 10) {
            if (isChrome) {
                minWeekSelect = year + "-W" + "0" + weekNumber;
            } else {
                minWeekSelect = weekNumber;
            }
        } else {
            if (isChrome) {
                minWeekSelect = year + "-W" + weekNumber;
            } else {
                minWeekSelect = weekNumber;
            }
        }
        return minWeekSelect;
    };

    const createWeekFormat = (week, yearToAdd = 0) => {
        const date = new Date();
        const year = (date.getFullYear() + yearToAdd);
        if (week < 10) {
            return year + "-W0" + week;
        } else {
            return year + "-W" + week;
        }
    };

    const weeks = [...Array(52).keys()];


    return (
        <div className="">
            <DataBlockLabel
                text={"Gewenst aflevermoment"}
                tooltip={"Donderdag voor 12.00 is de week erop in NL geleverd"}
                criticalMessage={null}
            />
            <div className="mt-2 bg-white rounded-tl-lg rounded-br-lg space-y-6">
                <div className="flex items-center">
                    <div className="w-full">
                        <div className="flex flex-col space-y-3">
                            {isChrome ? (
                                <input
                                    type="week"
                                    name="delivery_week"
                                    id="delivery_week"
                                    min={getMinWeekSelect()}
                                    required={isRequired}
                                    {...register("delivery_week", {
                                        required: isRequired,
                                    })}
                                    className={`bg-[#F6F5F3] w-full text-sm py-2 px-5 mt-1 rounded-none border-b-2 outline-none text-olaf-green-700 font-medium appearance-none resize-noneerrors?.note ${
                                        errors.delivery_week ? "border-red-500" : "border-white"
                                    }`}
                                />
                            ) : (
                                <select
                                    required={isRequired}
                                    {...register("delivery_week", {
                                        required: isRequired,
                                    })}
                                >
                                    {weeks.map((a, index) => {
                                        if (a + 1 < getMinWeekSelect()) {
                                            return;
                                        }
                                        return (<option
                                            value={createWeekFormat(a + 1)}
                                            key={a}
                                            disabled={a + 1 < getMinWeekSelect()}
                                            hidden={a + 1 < getMinWeekSelect()}
                                        >
                                            {createWeekFormat(a + 1)}
                                        </option>)
                                    })}
                                    {weeks.map((a, index) => (
                                        <option
                                            value={createWeekFormat(a + 1, 1)}
                                            key={a}
                                        >
                                            {createWeekFormat(a + 1, 1)}

                                        </option>
                                    ))}
                                </select>
                            )}
                        </div>
                    </div>
                </div>

                {errors.delivery_week &&
                    <p className={'font-bold text-red-700  text-base underline'}>Geen leverweek gekozen!</p>}
            </div>
        </div>
    );
}